import React, { useRef, useState } from "react";
import classNames from "classnames";
import Tag from "components/tag/Tag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import "./tagInput.scss";

export interface IInputProps {
  className?: string;
  label?: any;
  value?: any;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: any;
  multiLine?: any;
  labelHidden?: boolean;
  placeholder?: any;
  helpText?: any;
  tags?: any;
  onTagClick?: (index: number) => void;
  onFocus?: (e: any) => void;
  name?: string;
  id?: any;
  readOnly?: boolean;
}

const TagInput: React.FC<IInputProps> = props => {
  const { className, onChange, onKeyDown, id, ...rest } = props;
  const [inputStyle, setInputStyle] = useState({
    style: "tag-input_container",
  });

  const inputRef = useRef(null);

  function handleFocusStyleChange() {
    setInputStyle(prevState => ({ ...prevState, style: "tag-input_container_focused" }));
  }
  function handleBlurStyleChange() {
    setInputStyle(prevState => ({ ...prevState, style: "tag-input_container" }));
  }

  return (
    <div className={`tag-input ${className ? className : ""}`}>
      {!props.labelHidden ? (
        <div className="tag-input_label_container">
          <div className="tag-input_label">
            <label style={{ marginBottom: 0 }}>{props.label}</label>
          </div>
        </div>
      ) : null}

      <div className={inputStyle.style}>
        <div className="tag-input_tags_container" style={{ paddingBottom: props.tags.length > 0 ? "10px" : "0px" }}>
          {props.tags.map((tag: string, index: number) => {
            return (
              <div className="tag-input_single_tag_container" key={index}>
                <p className="tag-text">{tag}</p>

                <div className="flex items-center" onClick={e => props.onTagClick(index)}>
                  <FontAwesomeIcon fixedWidth icon={faXmark} className="tag-icon" />
                </div>
              </div>
            );
          })}
        </div>

        <div className="tag-input_input_container">
          <input
            name={props.name}
            ref={inputRef}
            value={props.value}
            placeholder={props.placeholder}
            onChange={props.onChange}
            onKeyDown={props.onKeyDown}
            onFocus={handleFocusStyleChange}
            onBlur={handleBlurStyleChange}
            id={props.id}
            readOnly={props.readOnly}
          />
        </div>
      </div>

      <div>
        <p className="tag-input_help_text">{props.helpText}</p>
      </div>
    </div>
  );
};

export default TagInput;
